module.exports = __webpack_public_path__ + "static/img/exciting-main-img.cb13d143.svg";